import { type ThemeConfig } from 'antd'

export const colors = {
  white: '#fff',
  black: 'rgba(57, 60, 62, 0.88)',
  secondary: '#6C757D',
  'secondary-active': '#596167',
  'secondary-hover': '#99a0a3',
  primary: '#727CF5',
  'primary-hover': '#eef0ff',
  green: '#52C41A',
  red: '#FA5C7C',
  yellow: '#FFBC00',
  info: '#1890FF',
  'info-active': '#096dd9',
  'info-hover': '#69c0ff',
  orange: {
    1: '#FFF7E6',
    5: '#FFA940',
    6: '#FA8C16',
    7: '#D46B08'
  },
  blue: {
    5: '#597EF7'
  },
  cyan: {
    1: '#E6FFFB'
  },
  magenta: {
    1: '#FFF0F6'
  },
  'green-1': '#F6FFED',
  'green-7': '#389E0D',
  'green-8': '#237804',
  gray: {
    0: '#F9FAFC',
    1: '#BCBCBC',
    2: '#999999'
  },
  'geek-blue': {
    1: '#F0F5FF'
  },
  body: '#F5F8FA',
  neutral: {
    2: '#fafafa',
    3: '#f5f5f5',
    4: '#f0f0f0',
    6: '#bfbfbf'
  },
  'table-border': 'rgba(0, 0, 0, 0.06)',
  'input-focus': '#727cf5',
  'input-hover': 'rgb(59 130 246 / 0.5)'
}

export const fontFamily = {
  pro: '"Noto Sans JP", sans-serif'
}

export const theme: ThemeConfig = {
  token: {
    colorLink: colors.primary,
    colorTextBase: colors.black,
    colorPrimary: colors.primary,
    colorSuccess: colors.green,
    colorError: colors.red,
    colorWarning: colors.yellow,
    fontFamily: fontFamily.pro,
    borderRadius: 2
  },
  components: {
    Layout: {
      bodyBg: colors.body
    },
    Menu: {
      itemColor: colors.secondary,
      itemHoverColor: colors.primary,
      itemBg: colors.white,
      itemSelectedColor: colors.secondary,
      itemSelectedBg: colors['primary-hover'],
      itemActiveBg: colors['primary-hover'],
      subMenuItemBg: colors.white,
      activeBarBorderWidth: 0,
      iconSize: 12,
      itemHeight: 48,
      itemMarginBlock: 0
    },
    Breadcrumb: {
      itemColor: colors.black,
      lastItemColor: colors.black,
      linkColor: colors.primary,
      linkHoverColor: colors.primary,
      colorBgTextHover: 'transparent',
      separatorColor: colors.gray[1]
    },
    Form: {
      // ラベルの色を変更
      labelColor: colors.black,
      // layout が vertical のラベルのパディングを変更
      verticalLabelPadding: '0 0 4px 0'
    },
    Table: {
      // Theadのテキスト色を変更
      headerColor: colors.secondary,
      // 選択列の幅を60pxに変更
      selectionColumnWidth: 60,
      // size が default のセルパディングを12pxに変更
      cellPaddingInline: 12,
      cellPaddingBlock: 12,
      // 配色自体はデフォルト（#f0f0f0）と変更はないが、行選択時の背景色との視認性を考慮してrgbaで指定
      borderColor: colors['table-border']
    },
    Pagination: {
      // アクティブページ数の背景色を透明に変更
      itemActiveBg: 'transparent'
    },
    Button: {
      // size が small のフォントサイズを13pxに変更
      contentFontSizeSM: 13
    },
    Collapse: {
      // コンテンツの余白を削除
      contentPadding: 0,
      // ヘッダーの背景色を変更
      headerBg: '#fbfbfb'
    }
  }
}
